var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-echart",style:({ height: _vm.height })},[_c('v-chart',{ref:"chart",staticClass:"base-echart__canvas",attrs:{"option":_vm.option,"loading":_vm.loading,"loading-options":_vm.loadingConfig,"autoresize":true,"init-options":_vm.initOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }